<template>
  <a-menu v-model:openKeys="openKeys" v-model:selectedKeys="selectedKeys" mode="inline">
    <a-menu-item key="sub0">
      <template #icon>
        <HomeOutlined />
      </template>
      首页
    </a-menu-item>
    <template v-if="type=='seal'">
      <a-sub-menu key="sub1">
        <template #icon>
          <AuditOutlined />
        </template>
        <template #title>印章管理</template>
        <a-menu-item key="1">公章管理</a-menu-item>
        <a-menu-item key="2">公章授权</a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="sub2">
        <template #icon>
          <FileTextOutlined />
        </template>
        <template #title>合同管理</template>
        <a-menu-item key="5">内部签约</a-menu-item>
        <a-menu-item key="7">外部签约</a-menu-item>
        <a-menu-item key="6">签约记录</a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="sub3">
        <template #icon>
          <SettingOutlined />
        </template>
        <template #title>系统管理</template>
        <a-menu-item key="9">用户管理</a-menu-item>
        <a-menu-item key="10">组织管理</a-menu-item>
        <a-menu-item key="11">日志管理</a-menu-item>
        <a-menu-item key="12">参数管理</a-menu-item>
      </a-sub-menu>
    </template>
    <template v-if="type == 'work'">
      <a-menu-item key="sub1">
        <template #icon>
          <FileTextOutlined />
        </template>
        全部事项
      </a-menu-item>
      <a-menu-item key="sub2">
        <template #icon>
          <FileTextOutlined />
        </template>
        待提交事项
      </a-menu-item>
      <a-menu-item key="sub3">
        <template #icon>
          <FileTextOutlined />
        </template>
        待审核事项
      </a-menu-item>
      <a-menu-item key="sub4">
        <template #icon>
          <FileTextOutlined />
        </template>
        进行中事项
      </a-menu-item>
      <a-menu-item key="sub5">
        <template #icon>
          <FileTextOutlined />
        </template>
        已完成事项
      </a-menu-item>
      <a-menu-item key="sub6">
        <template #icon>
          <FileTextOutlined />
        </template>
        抄送事项
      </a-menu-item>
    </template>
    <template v-if="type=='finance'">
      <a-menu-item key="sub1">
        <template #icon>
          <FileTextOutlined />
        </template>
        审批业务
      </a-menu-item>
    </template>
    <template v-if="type=='document'">
      <a-sub-menu key="sub1">
        <template #icon>
          <SettingOutlined />
        </template>
        <template #title>公文管理</template>
        <a-menu-item key="1">起草公文</a-menu-item>
        <a-menu-item key="2">我的公文</a-menu-item>
        <a-menu-item key="3">待收件</a-menu-item>
        <a-menu-item key="4">待传阅</a-menu-item>
        <a-menu-item key="5">文件管理</a-menu-item>
      </a-sub-menu>
    </template>
  </a-menu>
</template>
<script setup>
import { ref, defineProps, computed } from 'vue';
import { MailOutlined, QqOutlined, AppstoreOutlined, SettingOutlined, HomeOutlined, AuditOutlined, FileTextOutlined } from '@ant-design/icons-vue';
import { useRouter } from "vue-router";
const router = useRouter();
const props = defineProps({
  selected: {
    type: Array,
    default: ['1'],
  },
  open: {
    type: Array,
    default: ['sub1'],
  },
  type: {
    type: String,
    default: 'seal',
  }
});
const openKeys = computed(() => props.open);
const selectedKeys = computed(() => props.selected);

const toPath = (name) => {
  router.push({
    name: name
  })
}
</script>